import React from 'react';
import { Row, Col, Input, Form, Typography } from 'antd';

import whatsapp from '../../../assets/icons/whatsapp/01.svg';
import facebook from '../../../assets/icons/facebook/01.svg';
import instagram from '../../../assets/icons/instagram/01.svg';
import youtube from '../../../assets/icons/youtube/01.svg';
import twitter from '../../../assets/icons/twitter/01.svg';

export default function MainInformation(props) {
    return (
        <Row className='mb-35' gutter={20}>
            <Col span={24} className='mb-25'>
                <Typography.Title level={5} className='mt-0'>
                    Redes Sociales
                </Typography.Title>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Whatsapp"
                    name="whatsapp"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<img className='mr-3' style={{ height: 18 }} src={whatsapp} alt='...' />}
                        placeholder="Ingresar whatsapp"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Facebook"
                    name="facebook"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<img className='mr-3' style={{ height: 18 }} src={facebook} alt='...' />}
                        placeholder="Ingresar facebook"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Instagram"
                    name="instagram"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<img className='mr-3' style={{ height: 18 }} src={instagram} alt='...' />}
                        placeholder="Ingresar instagram"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Youtube"
                    name="youtube"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<img className='mr-3' style={{ height: 18 }} src={youtube} alt='...' />}
                        placeholder="Ingresar youtube"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Twitter"
                    name="twitter"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<img className='mr-3' style={{ height: 18 }} src={twitter} alt='...' />}
                        placeholder="Ingresar twitter"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
        </Row>
    )
}